export enum ProjectField {
  INSPECTION_DATE = "INSPECTION_DATE",
  INSPECTION_NOTES = "INSPECTION_NOTES",
  DRAW_NOTES = "DRAW_NOTES",
  DECLINE_REASON = "DECLINE_REASON",
  DRAW_SUBMITTAL_DATE = "DRAW_SUBMITTAL_DATE",
}
